import { render, staticRenderFns } from "./ChatEmpty.vue?vue&type=template&id=2d5bd6c6"
import script from "./ChatEmpty.vue?vue&type=script&lang=js"
export * from "./ChatEmpty.vue?vue&type=script&lang=js"
import style0 from "./ChatEmpty.vue?vue&type=style&index=0&id=2d5bd6c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports